import React from 'react'
import Box from '@mui/material/Box'
import styled from 'styled-components'

import { ActionCardProps } from 'types/TextAnalysis'

interface StyledBoxProps {
  $chipData: boolean
}

const StyledBox = styled(Box)<StyledBoxProps>(({ $chipData }) => ({
  margin: 0,
  paddingTop: $chipData ? '1rem' : 0,
}))

const CardTags = React.memo(function CardTags({ cardTags }: ActionCardProps) {
  if (!cardTags) return <></>

  let chipData: any[] = []
  if (Array.isArray(cardTags)) {
    chipData = cardTags
  } else if (cardTags && typeof cardTags === 'object' && 'props' in cardTags) {
    chipData = cardTags.props.chipData || []
  }

  return (
    <StyledBox data-testid="card-tags" $chipData={chipData.length > 0}>
      {cardTags}
    </StyledBox>
  )
})

export { CardTags }
